<template>
  <v-navigation-drawer app class="asta-drawer" v-model="drawer" fixed temporary>
    <!-- header -->
    <v-list-item class="navy">
      <v-icon left class="white--text">shield</v-icon>
      <v-list-item-content>
        <v-list-item-title class="text-caption navy--text text--darken-3"
          >Lega</v-list-item-title
        >
        <v-list-item-subtitle class="white--text">
          {{ asta_info.name }}
        </v-list-item-subtitle>
      </v-list-item-content>

      <v-btn rounded class="white--text" icon @click="toggle">
        <v-icon>close</v-icon>
      </v-btn>
    </v-list-item>

    <v-divider></v-divider>

    <div
      class="error white--text pa-2 ma-2"
      style="border-radius: 3px"
      v-if="!admin && !my_squadra"
    >
      Solo i presidenti delle squadre possono partecipare all'asta. I co-gestori
      e gli ospiti non possono parteciparvi ma possono seguirne l'andamento.
    </div>

    <v-list dense>
      <!-- User loggato -->
      <v-list-item link @click="gotoUser">
        <v-list-item-avatar>
          <v-img v-if="user_pic" contain :src="user_pic"></v-img>
          <v-icon v-else color="text">account_circle</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">
            <div>
              Ciao {{ user_displayName != "" ? user_displayName : user_uid }}
              <v-icon x-small right class="text--text">open_in_new</v-icon>
            </div>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- sblocca -->
      <v-list-item link @click="promptSblocco" v-if="!premium">
        <v-list-item-icon>
          <v-icon color="orange">workspace_premium</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="orange--text font-weight-bold"
            >Asta Live senza limiti</v-list-item-title
          >
          <v-list-item-subtitle
            ><div v-if="asta_info.counter">
              Hai ancora <b>{{ asta_info.counter }}</b> assegnazioni.
            </div>
            <div v-else>Sblocca per continuare.</div></v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <!-- Amministratore asta -->
      <v-list-item
        link
        v-if="!isAdminSet"
        @click="promptChangeAdmin"
      >
        <v-list-item-icon>
          <v-icon color="text">engineering</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold"
            >Nessun amministratore
          </v-list-item-title>
          <div class="error--text">Imposta amministratore d'asta</div>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        link
        v-else
        @click="promptChangeAdmin"
      >
        <v-list-item-icon>
          <v-icon color="text">engineering</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold"
            >Amministratore Asta
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ adminUsername }}
            <div class="stato" :class="adminPresenceClass"></div
          ></v-list-item-subtitle>
          <div
            :class="{
              'error--text': adminPresence != Constants.PRESENCE_STATES.ONLINE,
            }"
          >
            L'amministratore d'asta deve rimanere sempre online durante il corso
            dell'asta o Asta Live si bloccherà.
          </div>
        </v-list-item-content>
      </v-list-item>

      <!-- Impostazioni -->
      <v-list-item link @click="promptImpostazioni">
        <v-list-item-icon>
          <v-icon color="text">settings</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold"
            >Impostazioni asta</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>

      <!-- La mia squadra  -->
      <v-list-group v-if="my_squadra" :value="false">
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon color="text">admin_panel_settings</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="font-weight-bold"
              >La mia squadra</v-list-item-title
            >
            <v-list-item-subtitle>{{ mySquadraName }} </v-list-item-subtitle>
          </v-list-item-content>
        </template>

        <!-- Avatar -->
        <!-- <v-list-item class="navy" link @click="gotoUser">
          <v-list-item-avatar>
            <squadra-crediti :id="user_uid" xxSmall hideName></squadra-crediti>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title class="font-weight-bold white--text"
              ><div>
                Avatar<v-icon x-small right class="text--text"
                  >open_in_new</v-icon
                >
              </div>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->

        <!-- nome squadra -->
        <v-list-item class="navy" link @click="gotoNomeSquadra">
          <v-list-item-avatar>
            <v-icon color="white">abc</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title class="font-weight-bold white--text"
              ><div>
                Nome
                <v-icon x-small right class="text--text">open_in_new</v-icon>
              </div>
            </v-list-item-title>
            <!-- <v-list-item-subtitle>{{ mySquadraName }} </v-list-item-subtitle> -->
          </v-list-item-content>
        </v-list-item>

        <!-- pianifica -->
        <v-list-item class="navy" link @click="showPlan">
          <v-list-item-avatar>
            <v-icon color="white">design_services</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold white--text">
              <div>Pianifica crediti</div>
            </v-list-item-title>
            <!-- <v-list-item-subtitle>Ex Asta-Manager </v-list-item-subtitle> -->
          </v-list-item-content>
        </v-list-item>

        <!-- presidente-->
        <v-list-item class="navy" link @click="gotoGestoreSquadra">
          <v-list-item-avatar>
            <v-icon color="white">supervised_user_circle</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title class="font-weight-bold white--text"
              ><div>
                Gestore
                <v-icon x-small right class="text--text">open_in_new</v-icon>
              </div>
            </v-list-item-title>
            <v-list-item-subtitle class="navy--text text--lighten-2"
              >Solo presidenti.<br />No co-gestori in Asta
              Live</v-list-item-subtitle
            >
          </v-list-item-content>
          <!-- <v-list-item-action>
            <v-icon color="text"
              >info</v-icon
            ></v-list-item-action
          > -->
        </v-list-item>

        <!--  -->
      </v-list-group>

      <!-- download -->
      <v-list-item link @click="promptDownloadRose" v-if="admin || my_squadra">
        <v-list-item-icon>
          <v-icon color="text">download</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold"
            >Download Rose</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>

      <!-- salva rose -->
      <!-- <v-list-item link @click="promptSaveRose">
        <v-list-item-avatar>
          <v-icon color="text">save</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold"
            >Salva rose</v-list-item-title
          >
          <v-list-item-subtitle
            >Asta terminata? Salva assegnazioni</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item> -->

      <!-- inizializza rose -->
      <!-- <v-list-item link @click="promptImportRose">
        <v-list-item-avatar>
          <v-icon color="text">sync</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold"
            >Sovrascrivi rose/crediti</v-list-item-title
          >
          <v-list-item-subtitle
            >Se non vedi rose/crediti aggiornate.<br />
            Prima di aste di riparazioni.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item> -->

      <!-- tutorial -->
      <!-- <v-list-item link>
        <v-list-item-avatar>
          <v-icon color="text">school</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold"
            ><a
              class="blue-grey--text text-decoration-none"
              :href="Config.HOST + '/fantacalcio/tutorials/asta-live'"
              target="_blank"
              >Tutorial v.1.0</a
            ></v-list-item-title
          >
        </v-list-item-content>
      </v-list-item> -->

      <!-- Come funziona -->
      <v-list-item link @click="promptComeFunziona">
        <v-list-item-icon>
          <v-icon color="secondary">not_listed_location</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="secondary--text font-weight-bold"
            >Come funziona?</v-list-item-title
          >
          <v-list-item-subtitle>Guida veloce a Asta Live</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <!-- Supporto -->
      <v-list-item link>
        <v-list-item-icon>
          <v-icon color="text">support </v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold"
            ><a
              class="blue-grey--text text-decoration-none"
              href="https://www.facebook.com/groups/500245610367729/"
              target="_blank"
              >Supporto</a
            ></v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>

      <!-- weblink -->
      <v-list-item link v-if="is_mobile" @click="gotoAsta">
        <v-list-item-icon>
          <v-icon color="text">language</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold"
            >Web link
            <v-icon x-small right class="text--text"
              >open_in_new</v-icon
            ></v-list-item-title
          >
          <v-list-item-subtitle
            >Asta Live è disponibile anche in<br />
            una più comoda versione desktop<br />
            <span
              class="text--text text--lighten-2 text-decoration-underline"
              >{{ urlAsta }}</span
            >
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <div class="text-center">
      <v-btn small rounded outlined v-clipboard:copy="urlAsta" v-if="is_mobile">
        Copia link
      </v-btn>
    </div>

    <div class="version">
      <small>{{ version }}</small>
    </div>

    <!-- premium -->
    <!-- <div id="area-acquisto" v-if="!premium">
        <div v-if="asta_info.counter">
          Prova subito Asta Live! Usando questa versione <b>FREE</b> è possibile
          fare l'asta ancora per <b>{{ asta_info.counter }}</b>
          calciatori. Sblocca subito per non avere limiti.
        </div>
        <div v-else>
          Hai terminato le assegnazioni <b>FREE</b> dei calciatori. Sblocca
          l'asta per continuare.
        </div>
        <v-btn
          rounded
          class="orange white--text mt-1 mx-auto"
          v-if="!premium"
          @click="promptSblocco"
        >
          <v-icon small left>verified</v-icon>
          SBLOCCA
        </v-btn>
      </div> -->
  </v-navigation-drawer>
</template>

<script>
import db from "../js/db";
import Vuex from "vuex";

import mixins from "../js/mixins";
import toast from "../js/toast";
import Constants from "../js/constants";
import Config from "../../config-app/config";

import AstaChooser from "./dialogs/AstaChooser";
import SquadraCrediti from "./common/SquadraCrediti";

export default {
  name: "asta-drawer",
  mixins: [mixins, toast],
  components: {
    AstaChooser,
    SquadraCrediti,
  },

  mounted() {
    console.log("--> AstaDrawer mounted.");
    db.on("toggleDrawer", this.toggle);
    db.on("closeDrawer", this.toggle);
  },

  computed: {
    // user_pic2(){
    //   return "https://nations-devfpz.s3.eu-west-1.amazonaws.com/files/public/pictures/no-hexatar.png"
    // },
    urlAsta() {
      return (
        Config.HOST + "/pages/asta-live/main.php?ID_Lega=" + this.asta_info.id
      );
    },
    // mySquadra() {
    //   return this.asta_squadre[this.user_uid];
    // },
    mySquadraName() {
      return this.my_squadra ? this.asta_squadre[this.user_uid].name : "";
    },
    drawerClass() {
      return {
        "navigation-drawer--close": !this.drawer,
        "navigation-drawer--open": this.drawer,
      };
    },
    // shouldShowPlan() {
    //   return this.my_squadra && (this.is_mobile || this.planOrRose == "rose");
    // },
    ...Vuex.mapGetters([
      "migliore_offerta",
      // "asta_choosers",
      "svincolati_ids",
      "user_claims",
      "tot_squadre",
      "is_mobile",
      "version",
      "planOrRose",
      "user_displayName",
      "user_pic",
    ]),
  },
  data() {
    return {
      drawer: false,
    };
  },
  methods: {
    gotoUser() {
      window.open(Config.HOST + "/user/" + this.fp_uid(this.user_uid));
    },

    gotoNomeSquadra() {
      window.open(
        Config.HOST +
          "/fantacalcio/gestione-squadra-alias/" +
          this.my_squadra?.ID_Squadra
      );
    },
    gotoAsta() {
      window.open(this.urlAsta);
    },

    // gotoAdminLega() {
    //   window.open(
    //     Config.HOST + "/fantacalcio/gestione-lega/admin/" + this.asta_info.id
    //   );
    // },
    gotoGestoreSquadra() {
      window.open(
        Config.HOST +
          "/fantacalcio/gestione-squadra-aggiungi-gestore/" +
          this.my_squadra?.ID_Squadra
      );
    },
    promptComeFunziona() {
      db.emit("showComeFunziona");
    },
    promptSblocco() {
      db.emit("showSblocco");
    },
    promptImpostazioni() {
      db.emit("showImpostazioni");
      this.drawer = false;
    },
    promptDownloadRose() {
      db.emit("promptDownloadRose");
    },
    promptChangeAdmin() {
      db.emit("promptChangeAdmin");
    },
    toggle() {
      this.drawer = !this.drawer;
    },
    close() {
      this.drawer = false;
    },
    showPlan() {
      this.close();
      this.$store.dispatch("switchPlanOrRose", "plan");
      db.emit("showRoseOrPlan");
    },
  },
  destroyed() {
    console.log("<-- AstaDrawer destroyed.");
    db.off("toggleDrawer", this.toggle);
    db.off("closeDrawer", this.toggle);
  },
};
</script>

<style scoped>
.asta-drawer {
  width: 300px !important;
}
.version {
  bottom: 0;
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
}
</style>
